import { render, staticRenderFns } from "./coupon-ad.vue?vue&type=template&id=7ceadec0&scoped=true&"
import script from "./coupon-ad.vue?vue&type=script&lang=ts&"
export * from "./coupon-ad.vue?vue&type=script&lang=ts&"
import style0 from "./coupon-ad.vue?vue&type=style&index=0&id=7ceadec0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ceadec0",
  null
  
)

export default component.exports